<template>
	<div>
		<div class="title">
			<el-row style="margin: 0 0 10px 0 ;">
				<el-col :lg="22">
					<div class="waiTitel">
						<div class="green01"></div>
						<div class="title"
							style="margin: 0 0 0 3px; font-family: SourceHanSansCN-Bold; font-size: 18px;">抖音订单列表</div>
					</div>
				</el-col>
				<el-col :lg="2">
					<el-button @click="filterOrder()" size="small" icon="el-icon-refresh"
						style="margin-left: 10px;background-color: #ffffff; color: #000000; float: right;">刷新
					</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="tableCol">
			<p>
				<el-select v-model="query.type" style="width: 150px;margin-right: 10px;" size="small">
					<el-option v-for="item in keys" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-input type="text" style="width: 250px;margin-right: 20px;" size="small" v-model="query.text"
					@keydown.enter.native="filterOrder()">
				</el-input>
				<span style="margin-left: 10px; margin-right: 20px;">门店</span>
				<el-select v-model="query.storeId" @change="filterOrder()" clearable filterable
					style="width: 150px; margin-right: 30px;" size="small">
					<el-option-group label="营业门店" class="store">
						<el-option v-for="item in stores" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-option-group>
					<el-option-group label="结业门店">
						<el-option v-for="item in storesEnd" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-option-group>
				</el-select>
				类型
				<el-select v-model="query.orderType" @change="filterOrder()"
					style="width: 150px;margin-left: 10px;margin-right: 20px;" size="small">
					<el-option v-for="item in orderTypeList" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				退款来源
				<el-select v-model="query.refundSource" @change="filterOrder()"
					style="width: 150px;margin-left: 10px;margin-right: 20px;" size="small">
					<el-option v-for="item in refundSource" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				退款结果
				<el-select v-model="query.refundResult" @change="filterOrder()"
					style="width: 150px;margin-left: 10px;margin-right: 20px;" size="small">
					<el-option v-for="item in refundResult" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</p>
			<p>
				<el-select v-model="query.timeType" style="width: 150px;" size="small">
					<el-option key="0" label="提交时间" value="0">提交时间</el-option>
					<el-option key="1" label="付款时间" value="1">付款时间</el-option>
				</el-select>
				<el-date-picker v-model="query.time" @change="filterOrder()" type="daterange" size="small"
					style="margin-left: 10px;margin-right: 25px; width: 250px;" value-format="yyyy-MM-dd"
					range-separator="至">
				</el-date-picker>
				<span style="margin-left: 5px; margin-right: 10px;">支付方式</span>
				<el-select v-model="query.payType" @change="filterOrder()"
					style="width: 150px;margin-left: 0px;margin-top: 1px;" size="small">
					<el-option v-for="item in payMethodList" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				状态
				<el-select v-model="query.orderStatus" collapse-tags @change="filterOrder()"
					style="width: 150px;margin-left: 10px;margin-right: 20px;" size="small">
					<el-option v-for="item in orderStateList" :key="item.value" :label="item.label" :value="item.value"
						:disabled="query.orderStatus[0] == 100 && item.value != 100">
					</el-option>
				</el-select>
				<span style="float: right; ">
					<el-button size="small" class="buttonStyle01" @click="query.page = 1, filterOrder()">筛选
					</el-button>
					<el-button size="small" class="buttonStyle" @click="reload()">重置</el-button>
					<el-button size="small" class="buttonStyle" @click="expor()" style="margin-left: 20px;">导出订单
					</el-button>
				</span>
			</p>
			<div class="tabelContent" style="margin-top: 20px;">
				<el-table :data="orders" v-loading="loading"
					:header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D' }"
					style="width: 100%">
					<el-table-column prop="id" align="center" label="ID" width="70px"></el-table-column>
					<el-table-column prop="orderNo" align="center" label="订单编号" width="110px"></el-table-column>
					<el-table-column prop="dyOrderId" align="center" label="抖音内部订单" width="110px"> </el-table-column>
					<el-table-column label="商品服务" align="center" width="110">
						<template slot-scope="scope">
							{{ scope.row.type == null ? '/' : scope.row.type }}
						</template>
					</el-table-column>
					<!-- <el-table-column prop="orderType" align="center" label="订单类型" width="110">
						<template slot-scope="scope">
							{{ scope.row.orderType | typeFormat }}
						</template>
					</el-table-column> -->
					<el-table-column prop="nickName" align="center" label="用户昵称" width="120"></el-table-column>
					<el-table-column align="center" prop="phoneNum" label="联系电话" width="115"></el-table-column>
					<el-table-column align="center" prop="storeName" label="服务门店" width="100">
						<template slot-scope="scope">
							{{ scope.row.storeName ? scope.row.storeName : '无' }}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="workerName" label="发型师" width="65">
						<template slot-scope="scope">
							{{ scope.row.workerName ? scope.row.workerName : '无' }}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="payType" label="支付方式" width="83">
						<template slot-scope="scope">
							{{ scope.row.payType ? scope.row.payType : '/' }}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="total" label="服务价格" width="85">
						<template slot-scope="scope">
							{{ scope.row.total == null ? scope.row.payTotal == null ? '0' :
									scope.row.payTotal.toFixed(2)
									: scope.row.total.toFixed(2)
							}}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="payTotal" label="支付总额" width="85">
						<template slot-scope="scope">
							{{ scope.row.payTotal == null ? '0' : scope.row.payTotal.toFixed(2) }}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="addTime" label="添加时间" width="100"></el-table-column>
					<el-table-column align="center" prop="payTime" label="支付时间" width="100">
						<template slot-scope="scope">
							{{ scope.row.payTime ? scope.row.payTime : '/' }}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="vefiTime" label="审核时间" width="100">
						<template slot-scope="scope">
							{{ scope.row.vefiTime ? scope.row.vefiTime : '/' }}
						</template>
					</el-table-column>
					<el-table-column label="退款来源" align="center">
						<template slot-scope="scope">
							{{ scope.row.refundSource | refundSourceFormat }}
						</template>
					</el-table-column>
					<el-table-column label="退款原因" align="center">
						<template slot-scope="scope">
							{{ scope.row.refundReason}}
						</template>
					</el-table-column>
					<el-table-column align="center" label="劵码" width="70px">
						<template slot-scope="scope">
							{{ scope.row.dyCode ? scope.row.dyCode : '/' }}
						</template>
					</el-table-column>
					<el-table-column align="center" label="潮剪券" width="70px">
						<template slot-scope="scope">
							{{ scope.row.codeStatus | codeStatusFormat }}
						</template>
					</el-table-column>
					<el-table-column align="center" label="状态" width="90px" fixed="right">
						<template slot-scope="scope">
							<span v-if="scope.row.refundResult==0 || scope.row.refundResult ==null">
								<div v-if="scope.row.status ==-2" class=" Red">
									{{ statusRemark(scope.row.status) }}
								</div>
								<div v-else>
									{{ statusRemark(scope.row.status) }}
								</div>
							</span>
							<span v-else>
								{{scope.row.refundResult==1 && scope.row.refundResult !=null?"已退款":"拒绝退款"}}
							</span>
						</template>
					</el-table-column>
					<el-table-column align="center" label="操作" width="100" fixed="right">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click="show(scope.row.id)">详情 / 编辑</el-button>
							<!-- <el-button type="text" size="small" v-if="scope.row.status == -2 && scope.row.refundResult ==null" @click="refuseRefund(scope.row.orderNo)">拒绝退款</el-button> -->
						</template>
					</el-table-column>
				</el-table>
				<div style="text-align: center;">
					<el-pagination background @current-change="handleCurrentChange" @size-change="handleSizeChange"
						style="margin-top: 30px;" layout=" total, prev, pager, next, jumper" :current-page="query.page"
						:total="query.total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Q from 'q';
	import {
		url,
		formatMoney
	} from '../../utils/index.js'
	export default {
		data() {
			return {
				loading: false,
				url: url(),
				query: {
					page: 1,
					size: 10,
					total: null,
					type: 0,
					text: "",
					addTime: null,
					orderStatus: [],
					orderType: [],
					channel: "",
					payType: "",
					timeType: '0',
					time: [],
					storeId: '',
				},
				keys: [{
					label: "订单编号",
					value: 1,
				}, {
					label: "订单ID",
					value: 0,
				}, {
					label: "抖音内部订单ID",
					value: 5,
				}, {
					label: "抖音用户ID/手机号",
					value: 3,
				}, {
					label: "服务商品名称",
					value: 2,
				}, {
					label: "抖音券码",
					value: 4,
				}, ],
				fromList: [{
					label: "全部",
					value: "",
				}, {
					label: "小程序",
					value: "小程序",
				}, {
					label: "H5",
					value: "H5",
				}, ],
				payMethodList: [{
					label: "全部",
					value: "",
				}, {
					label: "微信支付",
					value: "微信支付",
				}, {
					label: "微信支付-现金",
					value: "微信支付-现金",
				}, {
					label: "抖音支付",
					value: "抖音支付",
				}, {
					label: "支付宝支付",
					value: "支付宝支付",
				}],
				orderStateList: [{
					label: "全部",
					value: '',
				}, {
					label: "待支付",
					value: 0,
				}, {
					label: "订单处理中",
					value: 1,
				}, {
					label: "取消订单",
					value: 2,
				}, {
					label: "已支付",
					value: 3,
				}, {
					label: "已发券已核销",
					value: 4,
				}, {
					label: "已发券已核销",
					value: 5,
				}, {
					label: "用户超时未支付",
					value: -1,
				}, {
					label: "退款申请",
					value: -2,
				}, {
					label: "退款成功",
					value: -3,
				}],
				orderTypeList: [{
					label: "全部",
					value: "",
				}, {
					label: "普通订单",
					value: "1",
				}, {
					label: "权益订单",
					value: "11",
				}, {
					label: "抖音核销",
					value: "4",
				}, {
					label: "会员订单",
					value: "6",
				}, {
					label: "会员续费订单",
					value: "7",
				}, {
					label: "春季次卡",
					value: "3",
				}, {
					label: "美团订单",
					value: "9",
				}, {
					label: "企业剪订单",
					value: "2",
				}, {
					label: "染发次卡订单",
					value: "10",
				}, {
					label: "膨胀券订单",
					value: "5",
				}, {
					label: "哈啰订单",
					value: "12",
				}, {
					label: "次卡订单",
					value: "13",
				}, {
					label: "卡金充值订单",
					value: "14",
				}, {
					label: "积分商城订单",
					value: "15",
				}],
				refundSource: [{
					label: "全部",
					value: "",
				}, {
					label: "用户发起退款",
					value: "1",
				}, {
					label: "过期自动退款",
					value: "3",
				}, {
					label: "客户退款",
					value: "4",
				}, {
					label: "预约失败或预约取消自动退款",
					value: "5",
				}],
				refundResult: [{
					label: "全部",
					value: "",
				}, {
					label: "无申请退款",
					value: "0",
				}, {
					label: "已退款",
					value: "1",
				}, {
					label: "拒绝退款",
					value: "2",
				}],
				// time: "",
				orders: [],
				stores: [], //营业门店
				storesEnd: [], //全部门店
				orderData: [{
					total: '',
					wechatTotal: '',
					meituanTotal: '',
					userCount: '',
					memberCount: '',
					memberTotal: '',
					enterprisePayTotal: '',
					haloTotal: ''
				}],
				customerTypeList: [{
					label: "生客",
					value: "0"
				}, {
					label: "熟客",
					value: "1"
				}, {
					label: "深度熟客",
					value: "2"
				}, {
					label: "首次消费",
					value: "3"
				}, ]
			};
		},
		computed: {
			statusRemark() {
				return (val) => {
					let result = '';
					this.orderStateList.forEach(ele => {
						if (ele.value == val) result = ele.label;
					});
					return result;
				}
			},
			customerType() {
				return (val) => {
					let result = '';
					this.customerTypeList.forEach(ele => {
						if (ele.value == val) result = ele.label;
					});
					return result;
				}
			},
		},
		filters: {
			typeFormat(val) {
				switch (val) {
					case "1":
						return "普通订单";
					case "3":
						return "次卡订单";
					case "10":
						return "染发次卡订单";
					case "5":
						return "膨胀券订单";
					case "6":
						return "会员订单";
					case "7":
						return "会员续费订单";
					case "9":
						return "美团订单";
					case "2":
						return "企业剪订单";
					case "11":
						return "权益订单";
					default:
						return "/";
				}
			},
			refundSourceFormat(val) {
				switch (val) {
					case "1":
						return "用户发起退款";
					case "3":
						return "次卡过期自动退款订单";
					case "4":
						return "客户退款";
					case "5":
						return "预约失败或预约取消自动退款";
					default:
						return "无";
				}
			},
			codeStatusFormat(val) {
				switch (val) {
					case "0":
						return "未领取";
					case "1":
						return "已领取";
					case "2":
						return "已使用";
					default:
						return "/";
				}
			}
		},
		mounted() {
			this.getOrders(1);
			this.getStores();
			this.getSummary(1);
		},
		methods: {
			show(id) {
				this.$router.push({
					path: "/DyOrderEdit",
					query: {
						id: id
					}
				});
			},
			reload() {
				this.query = {
					page: 1,
					size: 10,
					total: 0,
					type: 0,
					text: "",
					addTime: null,
					orderStatus: [],
					orderType: "",
					channel: "",
					payType: "",
					timeType: '0',
					time: [],
				};
				this.filterOrder()
			},
			handleCurrentChange(val) {
				this.query.page = val;
				if (this.query.time[0] != undefined || this.query.time[0] != null) {
					this.getOrders()
				} else {
					this.getOrders(1)
				}
			},
			handleSizeChange(val) {
				this.query.size = val;
				if (this.query.time[0] != undefined || this.query.time[0] != null) {
					this.getOrders()
				} else {
					this.getOrders(1)
				}
			},
			expor() {
				if (this.query.time != null) {
					let a = this.requestData()
					var parm = this.toString(a)
					window.location.assign(this.url + "dDyOrder/exportDyList" + parm)
				} else {
					this.$message.error("请设置时间范围再导出")
				}
			},
			toString(a) {
				var result = '?page=' + a.page + '&size=' + a.size
				if (a.type != undefined) {
					result += '&type=' + a.type
				}
				if (a.text != undefined) {
					result += '&text=' + a.text
				}
				if (a.startTime != undefined) {
					result += '&startTime=' + a.startTime
				}
				if (a.endTime != undefined) {
					result += '&endTime=' + a.endTime
				}
				if (a.orderStatus != undefined && a.orderStatus != "") {
					result += '&orderStatus=' + a.orderStatus
				}
				if (a.orderType != undefined) {
					result += '&orderType=' + a.orderType
				}
				if (a.payType != undefined) {
					result += '&payType=' + a.payType
				}
				if (a.storeId != undefined) {
					result += '&storeId=' + a.storeId
				}
				if (a.timeType != undefined) {
					result += '&timeType=' + a.timeType
				}
				return result
			},
			requestData(t) {
				var arr = {
					page: this.query.page,
					size: this.query.size,
				}
				if (t == 1) {
					arr.startTime = new Date().getFullYear() + '-01-01'
					arr.endTime = new Date().getFullYear() + '-12-31'
				} else {
					if (this.query.time.length > 0) {
						arr.timeType = this.query.timeType
						arr.startTime = this.query.time[0]
						arr.endTime = this.query.time[1]
					}
				}
				console.log(this.query.orderStatus)
				if (this.query.orderStatus != null) {
					arr.orderStatus = this.query.orderStatus
				}
				if (this.query.orderType != '') {
					arr.orderType = this.query.orderType
				}
				if (this.query.payType != '') {
					arr.payType = this.query.payType
				}
				if (this.query.storeId != '') {
					arr.storeId = this.query.storeId
				}
				if (this.query.text != '') {
					arr.type = this.query.type
					arr.text = this.query.text
				}
				// 退款来源、退款结果
				if (this.query.refundSource != '') {
					arr.refundSource = this.query.refundSource
				}
				if (this.query.refundResult != '') {
					arr.refundResult = this.query.refundResult
				}
				if (this.query.text != '' && this.query.time.length == 0 && this.query.time.length != null) {
					delete arr.timeType
					delete arr.startTime
					delete arr.endTime
				}
				console.log(arr)
				return arr;
			},
			filterOrder() {
				if (this.query.time != null && (this.query.time[0] != undefined || this.query.time[0] != null)) {
					this.getOrders();
					// this.getSummary();
				} else {
					this.getOrders(1);
					// this.getSummary(1);
				}
			},
			getOrders(type) {
				this.loading = true;
				let t = setTimeout(() => { //15秒超时
					this.loading = false
					this.$message.error("请求失败")
				}, 15000)
				var a;
				if (type == 1) {
					a = this.requestData(1)
				} else {
					a = this.requestData()
				}
				this.$http.get("dDyOrder/list", {
					params: a
				}, {
					emulateJSON: true
				}).then(res => {
					console.log(res)
					if (res.body.code == 200) {
						this.orders = res.body.data.rows;
						this.query.total = res.body.data.total;
					} else {
						this.$message.error(res.data.msg);
					}
					this.loading = false
					clearTimeout(t)
				})
			},
			getSummary(type) {
				this.loading = true;
				let t = setTimeout(() => { //15秒超时
					this.loading = false
					this.$message.error("请求失败")
				}, 15000)
				var a;
				if (type == 1) {
					a = this.requestData(1)
				} else {
					a = this.requestData()
				}
				this.$http.get("dOrder/summary", {
					params: a
				}, {
					emulateJSON: true
				}).then(res => {
					if (res.data.code == 200) {
						const a = res.body.data;
						this.orderData[0].total = formatMoney(((a.orderTotal + a.memberTotal) / 100).toFixed(2))
						this.orderData[0].wechatTotal = formatMoney((a.wechatTotal / 100).toFixed(2))
						this.orderData[0].meituanTotal = formatMoney((a.meituanTotal / 100).toFixed(2))
						this.orderData[0].memberTotal = formatMoney((a.memberTotal / 100).toFixed(2))
						this.orderData[0].memberDetailTotal = formatMoney((a.memberDetailTotal / 100).toFixed(2))
						this.orderData[0].enterprisePayTotal = formatMoney((a.enterprisePayTotal / 100).toFixed(2))
						this.orderData[0].haloTotal = formatMoney((a.haloTotal / 100).toFixed(2))
						this.orderData[0].timeCardTotal = formatMoney((a.timeCardTotal / 100).toFixed(2))
						this.orderData[0].userCount = formatMoney(a.userCount, 0)
						this.orderData[0].memberCount = formatMoney(a.memberCount, 0)
						this.loading = false
						clearTimeout(t)
						console.log("销毁定时器")
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},
			getStores() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						if (ele.businessType === 1) {
							this.storesEnd.push(ele) //结业门店
						} else {
							this.stores.push(ele) //营业门店
						}
					})
				})
			},
			refuseRefund(orderNo) {
				// this.$http.get("https://cj.ciaojian.com/bytedance/pay/merchant_audit?outRefundNo="+ orderNo +"&status=2&message=aa").then(res => {
				this.$http.get("https://cj.ciaojian.com/bytedance/pay/merchant_audit?outRefundNo=" + orderNo +
					"&status=2&message='未填写拒绝原因'").then(res => {
					console.log(res)
					if (res.body.code) {
						this.$message.success('修改成功');
						this.getOrders();
					}
				})
			}
		}
	};
</script>


<style lang="less" scoped>
	.grid-content {
		border-radius: 4px;
		box-shadow: 2px 2px 3px 2px rgba(102, 102, 102, 0.5);
	}

	.main-number {
		font-family: SourceHanSansCN-Bold;
		font-size: 22px;
	}

	.topRight {
		height: 100px;
	}

	.topRight>div {
		margin-top: 5px;
	}

	.tableCol {
		border-radius: 4px;
		box-shadow: 2px 2px 3px 2px rgba(102, 102, 102, 0.5);
		margin: 30px -3px 0px -3px;
		padding: 5px 15px 30px 15px;
	}

	.bg-purple {
		background: #FFFFFF;
	}

	.main-content {
		padding: 30px 20px 20px 20px;
	}

	.waiTitel {
		display: flex;
		border-radius: 2px;
	}

	.green01 {
		height: 14px;
		width: 5px;
		background-color: #4AB52E;
		margin: 5px 0 0 0
	}

	.topTitle {
		display: flex;
	}

	.green02 {
		width: 5px;
		height: 5px;
		background: #4AB52E;
		margin: 15px 5px 0 5px
	}

	.topTitleSmall {
		margin: 5px 0 0 0;
		font-size: 16px;
		font-family: SourceHanSansCN-Bold;
	}

	.buttonStyle {
		// margin-right: 10px;
		font-family: SourceHanSansCN-Bold;
		background: #FFFFFF !important;
		border-radius: 5px;
		border: 1px solid #CBC9C9;
	}

	.buttonStyle01 {
		margin-right: 10px;
		font-family: SourceHanSansCN-Bold;
		color: #FFFFFF;
		background: #4AB52E !important;
		border-radius: 5px;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #4AB52E;
		border-radius: 5px;
		color: #FFF;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: #4AB52E;
	}

	/deep/.el-pagination.is-background .el-pager li:not(.disabled) {
		border-radius: 5px;
	}

	/deep/.el-icon-arrow-down:before {
		content: "\e6d1";

	}

	.Red {
		color: red;
	}
</style>